import { HostListener, inject, Injectable } from "@angular/core";

import { GlobalService } from "@shared/services";

@Injectable({
  providedIn: "root",
})
export class DeviceService {
  globalService = inject(GlobalService);

  init(): void {
    this.checkDeviceType(window.innerWidth);
  }

  @HostListener("window:resize", ["$event"])
  onResize(event: any): void {
    this.checkDeviceType(event.target.innerWidth);
  }

  private checkDeviceType(width: number): void {
    this.globalService.screenWidth.set(width);
    if (width < 440) {
      this.globalService.device.set("mobile");
    } else if (width >= 440 && width < 1200) {
      this.globalService.device.set("tablet");
    } else {
      this.globalService.device.set("desktop");
    }
  }
}
